import React from 'react'
import { Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useNavigate } from 'react-router-dom'
import GenericModal from '../GenericModal'
import { ButtonType } from '../GenericButton/styles'
import ROUTES from '../../consts/paths'
import { useUserRole } from '../../hooks/useUserRole'
import { translateUserFacingText } from '../../utils/userFacingTerminology'

interface BackgroundTaskModalProps {
  isOpen: boolean
  onClose: () => void
  taskMessage: string
  children?: React.ReactNode
}

const BackgroundTaskModal: React.FC<BackgroundTaskModalProps> = ({
  isOpen,
  onClose,
  taskMessage,
  children
}) => {
  const navigate = useNavigate()
  const { isGlobalRole } = useUserRole()

  const title = (
    <Box display="flex" alignItems="center" gap={1}>
      <InfoOutlinedIcon sx={{ fontSize: 24, color: 'primary.main' }} />
      Task in Progress
    </Box>
  )

  return (
    <GenericModal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="sm"
      confirmActionText="Go to Activity Monitor"
      onConfirm={async () => { navigate(ROUTES.TASKS) }}
      hideConfirmButton={!isGlobalRole}
      destructiveButtonText="OK"
      destructiveButtonType={ButtonType.Secondary}
    >
      <Box display="flex" flexDirection="column" gap={2} py={2}>
        <Typography variant="body1">
          {translateUserFacingText(taskMessage)}
        </Typography>
        {children != null && (
          <Box>
            {children}
          </Box>
        )}
      </Box>
    </GenericModal>
  )
}

export default BackgroundTaskModal
